export default __webpack_public_path__ + "static/media/svg-4.237d4992.svg";